<div v-if="shouldRenderConfig" v-bind:class="getClassName">
  <div class="matrix_selectOptionName" v-if="showName"><span>{{ propsData.label }}</span>
    <span v-if="getIsCimpressDefaultSelection">
      <label>
        <input type="checkbox" :checked="isHiddenInFrontend" @change="hidePageOptionInFrontend($event)" />
        {{ $t("Hide in frontend") }}
      </label>
    </span>
  </div>
  <input type="number" class="form-control" v-model="value" :placeholder="$t('Enter number')" v-on:keydown.enter="(event) => { event.preventDefault(); applyValue() }" />

  <div class="rangeDetailsContainer">
    <div class="rangeDetails" v-if="unitOfMeasure || ranges.length">
      <fragment v-if="unitOfMeasure">{{ $t("Unit of measure: {uom}", { uom: unitOfMeasure }) }}</fragment>
      <div class="allowed-ranges" v-if="ranges.length">
        {{ $t("Allowed values: {val}", { val: allowedRanges }) }}
      </div>
    </div>

    <button type="button" class="btn btn-primary rangeBtn" v-on:click="applyValue">
      {{ $t("Apply") }}
    </button>
  </div>
</div>

